<header>
    <div class="row">
        <div class="col-md-12" style="padding: 0;" style="background-image: url('./../../../assets/bg.png');background-repeat: no-repeat;background-size: cover;">
            <img src="./../../../assets/Logo2.png" alt="Dental Council of India" title="Dental Council of India">
            <!-- <a href="https://rashtragaan.in/">         
                <img src="./../../../assets/Logo75.png" class="tabView" alt="Dental Council of India" title="Dental Council of India">
            </a>
            <img src="./../../../assets/logoembdig.png" alt="Dental Council of India" title="Dental Council of India"> -->
       <img src="./../../../assets/Digital_India_logo.png" alt="Dental Council of India" title="Dental Council of India"
            style="position: absolute; top: 10px; right: 20px; height: 70px;">
        </div>
    </div>
    <div class="container h-100">
        <div class="align-items-center">
            <div class="global-container">
                <div class="card forgot-pwd-form">
                    <div class="card-body">
                        <div class="card-text">
                            <h4 class="headerStyles">Forgot User Id</h4>
                                <form [formGroup]="forgotusrForm">
                                    <div class="row form-group">
                                        <div class="col-md-6 form-group">
                                            <br><label><strong>Student Name <span class="text-danger">*</span></strong> </label>
                                            <input type="text" placeholder="Student Name" class="form-control"
                                                formControlName="studentName" maxlength="255" [(ngModel)]="studentDetails.studentName"
                                                [ngClass]="{ 'is-invalid': f.studentName.invalid && (f.studentName.dirty || f.studentName.touched) }">
                                            <div *ngIf="isSubmitted && forgotusrForm.controls['studentName'].hasError('required')"
                                                class="failed-validation" class="errorColor">
                                                Student Name is Required
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <br><label><strong>Father Name <span class="text-danger">*</span></strong> </label>
                                            <input type="text" placeholder="Father Name" class="form-control"
                                                formControlName="fatherName" maxlength="255" [(ngModel)]="studentDetails.fatherName"
                                                [ngClass]="{ 'is-invalid': f.fatherName.invalid && (f.fatherName.dirty || f.fatherName.touched) }">
                                            <div *ngIf="isSubmitted && forgotusrForm.controls['fatherName'].hasError('required')"
                                                class="failed-validation" class="errorColor">
                                                Father Name is Required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row form-group">
                                        <div class="col-md-6 form-group">
                                            <br><label><strong>Date of Birth <span class="text-danger">*</span></strong> </label>
                                            <input type="date" onkeydown="return false" placeholder="dd/mm/yyyy" class="form-control" formControlName="dateOfBirth"
                                            [(ngModel)]="studentDetails.dateOfBirth" [max]="maxAgeDate" 
                                            [ngClass]="{ 'is-invalid': f.dateOfBirth.invalid && (f.dateOfBirth.dirty || f.dateOfBirth.touched) }">
                                            <div *ngIf="isSubmitted && forgotusrForm.controls['dateOfBirth'].hasError('required')"
                                                class="failed-validation" class="errorColor">
                                                Date of Birth Required
                                            </div>
                                        </div>
                                        <div class="col-md-6 form-group">
                                            <br><label><strong>Mobile No. <span class="text-danger">*</span></strong> </label>
                                            <input type="text" placeholder="Mobile No" class="form-control" formControlName="mobileNumber"
                                                maxlength="10" minlength="10" (keypress)="keyPress($event)" maxlength="10"
                                                [ngClass]="{ 'is-invalid': f.mobileNumber.invalid && (f.mobileNumber.dirty || f.mobileNumber.touched) }"
                                                data-validation-error-msg='Mobile Number is required' data-validation-regexp="^[6-9][0-9]*$"
                                                data-validation="required length number custom" data-validation-length="10-10" [(ngModel)]="studentDetails.mobileNumber">
                                            <div *ngIf="isSubmitted && forgotusrForm.controls['mobileNumber'].hasError('required')"
                                                class="failed-validation" class="errorColor">
                                                Mobile No is Required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">                                            
                                        </div>
                                        <div class="col-md-7">
                                            <div class="wrapper">                                                 
                                                <div class="captcha-area">
                                                    <div class="captcha-img">
                                                    <img src='/assets/captcha-bg.png' alt="Captch Background"/>
                                                    <span class="captcha">{{captchaImage}}</span>
                                                    </div>
                                                    &nbsp; <button class="reload-btn" (click)="getCaptchaValue()"><i class="fas fa-redo-alt" (click)="getCaptchaValue()"></i></button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">                                            
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-2">                                            
                                        </div>
                                        <div class="form-group col-md-7">
                                            <input type="text" class="form-control" placeholder="Enter Captcha" formControlName="captcha" 
                                            [ngClass]="{ 'is-invalid':  submitted && f.captcha.errors }" maxlength="5" autocomplete="new-password">
                                            <div *ngIf=" submitted && f.captcha.errors" class="invalid-feedback">
                                                <div *ngIf=" submitted && f.captcha.errors.required">Captcha {{errorMsgs.required}}</div>
                                            </div>
                                        </div>
                                        <div class="col-md-3">                                            
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">                                            
                                        </div>
                                        <div class="col-md-7">
                                            <button class="form-control btn btn-primary" type="button" [disabled]="!forgotusrForm.valid" (click)="getRandomKeyGenerator()">Submit</button>
                                        </div>
                                        <div class="col-md-3">                                            
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2">                                            
                                        </div>
                                        <div class="col-md-7" style="padding-top: 5px;text-align: center;font-size: 15px;">
                                            <p>
                                                <a routerLink="../login" *ngIf="!moduleStdReg">Login</a>
                                                <a routerLink="../../login/student" *ngIf="moduleStdReg">Login</a>
                                            </p>
                                        </div>
                                        <div class="col-md-3">                                            
                                        </div>
                                    </div>
                                </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>